import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Card, Table, Row, Col, Tag } from 'antd';

import Viewer from './index';

const types = {
  TABLE: 'table',
  LIST_CARD: 'list-card'
};
let keyCount = 0;

class ViewerList extends Component {
  static defaultProps = {
    type: 'list-card', /* table, list-card */
    fieldNameStatus: '_STATUS_',
    fieldNameTitle: '_TITLE_',
    fieldNameTag: '_TAG_',
    fieldNameIdentifier: '_ID_',
    columns: 2
  }

  constructor(props) {
    super(props);
    this.state = {
    };
  }


  getColumns = () => {
    const { rowActionsRender, items } = this.props;
    if (!items || items.length === 0 || !items[0].fieldItemGroups) {
      return [];
    }
    if (items[0].fieldItemGroups.length === 0 || !items[0].fieldItemGroups[0].fieldItems) {
      return [];
    }

    const columns = items[0].fieldItemGroups[0].fieldItems.filter(x=> !x.action).map(x => ({
      title: x.label || x.alias,
      dataIndex: x.name,
    }));

    if (rowActionsRender) {
      columns.push(
        {
          title: 'Ações',
          key: 'acoes',
          className: 'collapsing',
          render: rowActionsRender
        });
    }
    return columns;
  }

  getDataSource = () => {
    const { items, fieldNameIdentifier } = this.props;
    if (!items || items.length === 0 || !items[0].fieldItemGroups) {
      return [];
    }
    if (items[0].fieldItemGroups.length === 0 || !items[0].fieldItemGroups[0].fieldItems) {
      return [];
    }
    const dataSource = [];
    
    
    items.forEach(item => {
      const fields = {};
      fields.__ = item;
      fields[fieldNameIdentifier] = item[fieldNameIdentifier];
      item.fieldItemGroups[0].fieldItems.forEach(x => {
        if(!x.action)
        fields[x.name] = x.value;
      });
      
      fields.actions =  item.fieldItemGroups[0].fieldItems.filter(x => x.action);
      
      dataSource.push(fields);
    });
    return dataSource;
  }

  expandedRowRender = (item) => {
    if (this.props.expandedRowRender) {
      return this.props.expandedRowRender(item.__);
    }
  }

  renderTable = () => {
    const { fieldNameIdentifier, pagination, expandedRowKeys, onExpandedRowsChange, onChange } = this.props;
    const columns = this.getColumns();
    const dataSource = this.getDataSource();

    return (<div>
      <Table
        dataSource={dataSource} columns={columns}
        size="middle"
        pagination={pagination}
        expandedRowKeys={expandedRowKeys}
        onExpandedRowsChange={onExpandedRowsChange}
        expandedRowRender={this.expandedRowRender}
        rowKey={fieldNameIdentifier}
        onChange={onChange}
      />
    </div>
    );
  }


  renderRowCards = () => {
    const { items, columns } = this.props;
    if (!items || items.length === 0) return null;

    let cols;
    const rows = [];
    for (let i = 0, count = items.length; i < count; i += columns) {
      cols = [];

      for (let j = 0; j < columns; j++) {
        if (count > i + j) {
          cols.push({ key: `col__${new Date().getTime()}_${keyCount++}`, values: items[i + j] });
        }
      }
      rows.push({ key: `row__${new Date().getTime()}_${keyCount++}`, cols });
    }

    return (
      rows.map(r => (
        <Row key={r.key} gutter={12}>
          {r.cols.map(c => (
            <Col sm={24} md={parseInt(24 / columns, 10)} key={c.key}>
              {this.renderCard(c.values)}
            </Col>
          ))}
        </Row>
      ))
    );
  }

  renderCard = (values) => {
    const { fieldGroups } = this.props;
    return (
      <Card title={this.renderTitle(values)}>

        <Viewer
          type='tables'
          fieldGroups={fieldGroups} values={values}
        />

      </Card>
    );
  }

  renderTitle = (values) => {
    const { fieldNameTag, fieldNameTitle, fieldNameIdentifier } = this.props;
    const url = this.props.url.replace('{id}', values[fieldNameIdentifier]);
    return (
      <div>
        {!!values[fieldNameTag] && <Tag status="error">{values[fieldNameTag]}</Tag>}
        {<Link to={url}>{values[fieldNameTitle]}</Link>}
      </div>
    );
  }


  render() {
    const { type } = this.props;
    if (type === types.TABLE) {
      return (
        <div>
          {this.renderTable()}
        </div>
      );
    }

    if (type === types.LIST_CARD) {
      return (
        <div>
          {this.renderRowCards()}
        </div>
      );
    }

    return <big style={{ color: 'red !important' }}>{type} não é um type Válido!!!</big>;
  }
}

export default ViewerList;
